import { UserFullFragment } from '@generated/UserFullFragment';

export enum USER_PROFILE_TABS {
  GENERAL = 'general',
  NUMBERS_TEAMS = 'numbers-teams',
  WORKING_HOURS = 'working-hours',
  CALL_PREFERENCES = 'call-preferences',
  NOTIFICATIONS = 'notifications',
}

export interface UserProfileTabProps {
  user: UserFullFragment;
}
